export default "__VITE_ASSET__piSwXPVH__"